<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品评价</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="evaluateForm" :model="evaluateForm" label-width="120px" v-loading="loading">
      <div class="evaluate-header">订单号：{{orderNumber}}</div>
      <div class="evaluate-content">
        <div class="evaluate-card shop">
          <div class="card-left">
            <el-image class="shop-logo" :src="storeInfo.logo" fit="contain"></el-image>
            <div class="shop-name">{{ storeInfo.name }}</div>
            <div class="shop-memo">{{ storeInfo.sortname }}</div>
          </div>
          <div class="card-right">
            <el-form-item label="服务评分" prop="serviceScore" :rules="[
              { required: true, message: '请对商家服务评分', trigger: 'blur' },
              { type: 'number', min: 1, message: '请对商家服务评分', trigger: 'change'}
            ]">
              <el-rate class="rateBox" v-model="evaluateForm.serviceScore"></el-rate>
            </el-form-item>
            <el-form-item label="发货速度评分" prop="speedScore" :rules="[
              { required: true, message: '请对发货速度评分', trigger: 'blur' },
              { type: 'number', min: 1, message: '请对发货速度评分', trigger: 'change'}
            ]">
              <el-rate class="rateBox" v-model="evaluateForm.speedScore"></el-rate>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="evaluate-content">
      <div class="evaluate-card good" v-for="(good, index) in evaluateForm.goodsList" :key="good.goodId">
        <div class="card-left">
          <el-image class="good-logo" :src="good.goodImage" fit="contain"></el-image>
          <div class="good-title">{{ good.goodsName }}</div>
          <div class="good-sku">{{ good.goodSku }}</div>
          <div class="good-price">￥{{ good.goodPrice }}</div>
        </div>
        <div class="card-right">
          <el-form-item label="描述相符" :prop="`goodsList.${index}.matchScore`" :rules="[
            { required: true, message: '请对商品与描述相符度评分', trigger: 'change' },
            { type: 'number', min: 1, message: '请对商品与描述相符度评分', trigger: 'change'}
          ]">
            <el-rate class="rateBox" v-model="good.matchScore"></el-rate>
          </el-form-item>
          <el-form-item label="商品评价" :prop="`goodsList.${index}.starLevel`" :rules="[
            { required: true, message: '请对商品评分', trigger: 'change' },
            { type: 'number', min: 1, message: '请对商品评分', trigger: 'change'}
          ]">
            <el-rate class="rateBox" v-model="good.starLevel"></el-rate>
          </el-form-item>
          <el-form-item label="评价晒单" prop="content">
            <el-input v-model="good.content" type="textarea" :rows="4" placeholder="请输入商品体验心得"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="picture-list">
              <el-upload name="files" :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                         ref="upload" list-type="picture-card" multiple
                         :limit="6"
                         :on-remove="(file) => handlePictureRemove(file, good)"
                         :on-exceed="overLimit"
                         :on-success="(res, file) => handleUploadSuccess(res ,file,  good)">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
        </div>
      </div>
    </div>
    </el-form>
    <div class="evaluate-footer">
      <el-button type="primary" class="btn-evaluate" @click="submitEvaluate">发表</el-button>
      <el-checkbox v-model="isAnonymous">是否匿名</el-checkbox>
    </div>
  </div>
</template>
<script>
import {postComment, fetchOrderDetail, storeList} from "../../../api/xunyou";

export default {
  data() {
    return {
      loading: false,
      orderDetail: '',
      storeInfo: '',
      isAnonymous: false,
      list: [],
      evaluateForm: {
        speedScore: 0,
        serviceScore: 0,
        goodsList: []
      }
    };
  },
  computed: {
    orderNumber () {
      return this.$route.query.orderNumber;
    },
    bxmId () {
      return this.$route.query.bxmId;
    }
  },
  created() {
    this.getOrderDetail();
    this.searchStoreList();
  },
  methods: {
    handlePictureRemove (file, good) {
      const _index = good.images.findIndex(ele => ele.uid === file.uid);
      if (_index > -1) {
        good.images.splice(_index, 1);
      }
    },
    handleUploadSuccess(res, file, good) {
      if (res.code === 0) {
        good.images.push({
          uid: file.uid,
          url: res.url
        });
      }
    },
    // 文件数目超限
    overLimit (files, fileList) {
      this.$message.warning('最多上传6张图片');
    },
    // 订单详情查询
    getOrderDetail () {
      this.loading = true;
      fetchOrderDetail({ orderNumber: this.orderNumber })
        .then(res => {
          console.log('订单详情：', res);
          this.loading = false;
          if (res.code === 0) {
            this.orderDetail = res.data;
            this.evaluateForm.goodsList = res.data.orderCommodityList.map(good => ({
              goodPrice: good.buyprice,
              goodImage: good.specificationImg || good.commodityImage,
              goodSku: good.attributes,
              goodsName: good.commodityName,
              goodId: good.commodityId,
              starLevel: 0,
              content: '',
              images: [],
              isAnonymous: 2,
              matchScore: 0
            }));
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
        this.loading = false;
        this.$message.error('请求失败，请稍候重试');
      });
    },
    // 店铺查询
    searchStoreList() {
      storeList({
        userId: this.$store.getters.userId,
        bxmId: this.bxmId,
      }).then((res) => {
        console.log('店铺信息：', res);
        if (res.code === 0) {
          this.storeInfo = res.rows[0];
        }
      }).catch((err) => {
        this.$message.error("店铺查询失败，请稍后再试！");
      });
    },
    // 发表评价
    submitEvaluate () {
      this.$refs.evaluateForm.validate(valid => {
        if (valid) {
          const params = {
            oid: this.orderDetail.oid,
            muid: this.$store.getters.userId,
            merchantEvaluation: {
              bxmId: this.orderDetail.bxmId,
              name: this.orderDetail.merchantName,
              isAnonymous: this.isAnonymous ? 1 : 2,
              serviceScore: this.evaluateForm.serviceScore,
              speedScore: this.evaluateForm.speedScore
            },
            goodsEvaluations: this.evaluateForm.goodsList.map(good => ({
              goodsName: good.goodsName,
              goodId: good.goodId,
              starLevel: good.starLevel,
              content: good.content,
              images: good.images.map(ele => ele.url).join(','),
              isAnonymous: this.isAnonymous ? 1 : 2,
              matchScore: good.matchScore
            }))
          }
          this.loading = true;
          postComment(params).then(res => {
            console.log('评价结果：', res);
            this.loading = false;
            if (res.code === 0) {
              this.$message.success('评价成功！');
              this.$router.back();
            } else {
              this.$message.success(res.msg);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('评价失败');
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.evaluate-content,.evaluate-footer{
  background-color: #fff;
  padding: 15px;
  margin-bottom: 10px;
}
.evaluate-header{
  padding: 10px;
  font-weight: 500;
  border-bottom: 1px solid #ECECEC;
  background-color: #fff;
}
.evaluate-card{
  .card-left{
    display: inline-block;
    width: 380px;
    border-right: 1px dashed #ECECEC;
    vertical-align: middle;
  }
  .card-right{
    display: inline-block;
    width: 700px;
    vertical-align: middle;
  }
  .shop-logo{
    width: 120px;
    height: 120px;
    border: 1px solid #ececec;
    background-color: #F5F5F5;
    border-radius: 50%;
    float: left;
    margin-right: 10px;
  }
  .shop-memo{
    color: #888888;
  }
  .shop-name{
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 30px;
  }
  &.good>.card-left{
    text-align: center;
    .good-logo{
      width: 120px;
      height: 120px;
    }
    .good-sku{
      color: #888888;
      margin: 10px 0;
    }
    .good-price{
      color: var(--main-theme-color);
      font-weight: 500;
    }
  }
  .rateBox{
    margin-top: 10px;
  }
  /deep/ .el-form-item{
    margin-bottom: 10px;
    .el-form-item__error{
      top: 80%;
    }
  }
}
.picture-list{
  padding: 10px 0;
  /deep/ .el-upload--picture-card{
    width: 60px;
    height: 60px;
    line-height: 70px;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item{
    width: 60px;
    height: 60px;
  }
}
.evaluate-footer{
  text-align: center;
  .btn-evaluate{
    width: 200px;
    margin-right: 20px;
  }
}

</style>







// WEBPACK FOOTER //
// src/views/myOrder/evaluationePage/orderAppraisal.vue